<script lang="ts">
  import { createMutation, useQueryClient } from '@tanstack/svelte-query';
  import { debtApi } from '$lib/api/debt';
  import { getErrorMessage } from '$lib/api/client';
  import { toast } from '$lib/state/toast.svelte';
  import Modal from '$lib/components/ui/Modal.svelte';

  const { projectId, onClose }: { projectId: number; onClose: () => void } = $props();
  const queryClient = useQueryClient();

  let desc = $state('');
  let severity = $state('medium');
  let ceiling = $state('');
  let formError = $state('');

  const mutation = createMutation(() => ({
    mutationFn: () => debtApi.create(projectId, { desc: desc.trim(), severity, ceiling: ceiling.trim() }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['project-debt', projectId] });
      onClose();
      toast.success('Debt entry added');
    },
    onError: (err: unknown) => (formError = getErrorMessage(err))
  }));

  function submit(e: SubmitEvent) {
    e.preventDefault();
    if (!desc.trim()) {
      formError = 'Description is required';
      return;
    }
    formError = '';
    mutation.mutate();
  }
</script>

<Modal title="Add debt entry" {onClose}>
  {#snippet footer()}
    <span class="spacer"></span>
    <button type="button" class="btn btn-secondary" onclick={onClose}>Cancel</button>
    <button type="submit" form="debt-form" class="btn btn-primary" disabled={!desc.trim() || mutation.isPending}>Add entry</button>
  {/snippet}

  <form id="debt-form" onsubmit={submit}>
    <div class="field">
      <label class="label" for="db-desc">Description</label>
      <textarea id="db-desc" class="textarea" style="min-height:72px" placeholder="e.g. O(n²) topology scan on scene apply" bind:value={desc}></textarea>
    </div>
    <div class="field">
      <label class="label" for="db-sev">Severity</label>
      <select id="db-sev" class="select" bind:value={severity}>
        {#each ['low', 'medium', 'high'] as s (s)}
          <option value={s}>{s[0].toUpperCase() + s.slice(1)}</option>
        {/each}
      </select>
    </div>
    <div class="field">
      <label class="label" for="db-ceiling">Ceiling note</label>
      <input id="db-ceiling" class="input" placeholder="e.g. Fine under 1k rooms — revisit for hotel-scale" bind:value={ceiling} />
    </div>
    {#if formError}<p style="color:var(--danger);font-size:13px">{formError}</p>{/if}
  </form>
</Modal>
